import React, { memo } from 'react';
import { Helmet } from 'react-helmet';

interface MazeSnippetProps {
  enabled: boolean;
}

export const MazeSnippet: React.FC<MazeSnippetProps> = memo(({ enabled }) => {
  if (!enabled) {
    return null;
  }
  return (
    <Helmet>
      <script>
        {/* @ts-ignore this component does not support "children" prop properly */}
        {((m, a: any, z, e) => {
          let s, t;
          try {
            t = m.sessionStorage.getItem('maze-us');
          } catch (err) {}

          if (!t) {
            t = new Date().getTime();
            try {
              m.sessionStorage.setItem('maze-us', t.toString());
            } catch (err) {}
          }

          s = a.createElement('script');
          s.src = z + '?apiKey=' + e;
          s.async = true;
          a.getElementsByTagName('head')[0].appendChild(s);
          (m as any).mazeUniversalSnippetApiKey = e;
        })(
          window,
          document,
          'https://snippet.maze.co/maze-universal-loader.js',
          '4e4b8755-a687-4b83-bebc-7be0d043876d'
        )}
      </script>
    </Helmet>
  );
});
